import React from "react";
import { Space, Input, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { UI_COLORS } from "../../config";

/**
 * Presentational search bar used by KeysList
 */
export default React.memo(function SearchBar({ value, onChange, onSubmit, placeholder }) {
  return (
    <Space.Compact block>
      <Input
        size="small"
        style={{ width: "96%", height: 32, borderColor: "#d9d9d9" }}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onPressEnter={onSubmit}
      />
      <Button
        style={{
          backgroundColor: UI_COLORS.primary,
          color: UI_COLORS.white,
          cursor: "pointer",
        }}
        icon={<FontAwesomeIcon icon={faMagnifyingGlass} />}
        onClick={onSubmit}
      />
    </Space.Compact>
  );
});